import Vue from 'vue';
import Router from 'vue-router';
import Login from './views/Login/Login.vue';
import Logout from './views/Logout/Logout.vue';
import Dashboard from './views/Dashboard/Dashboard.vue';
import Request from './views/Company/FleetDriver/Request/Request.vue';
import DashboardFleetDriver from './views/Company/FleetDriver/Dashboard/Dashboard.vue';
import ProductGroupd from './views/Products/Groups/Group.vue';
import ProductFamily from './views/Products/Families/Family.vue';
import ProductBrand from './views/Products/Brands/Brand.vue';
import ProductParts from './views/Products/Parts/Part.vue';
import PerfilTruck from './views/Company/PerfilTruck/Perfil.vue';
import PerfilTruckTrailer from './views/Company/PerfilTruckTrailer/Perfil.vue';
import PerfilTruckService from './views/Company/PerfilTruckService/Perfil.vue';
import PerfilCertified from './views/Company/PerfilCertified/Perfil.vue';
import WorkHours from './views/Company/WorkHours/WorkHours.vue';
import CompanyRegistration from './views/Company/CompanyRegistration.vue';
import CrudCompany from './views/Company/Crud/Company.vue';
import Trucker from './views/Trucker/Crud/Trucker.vue';
import TruckerFleetDriver from './views/Company/FleetDriver/Trucker/Trucker.vue';
import TruckTrailer from './views/TruckTrailer/Crud/TruckTrailer.vue';
import Truck from './views/Truck/Crud/Truck.vue';
import TruckAdmin from './views/Truck/Admin/Truck.vue';
import TruckTrailerAdmin from './views/TruckTrailer/Admin/TruckTrailer.vue';
import ConnectTruck from './views/Truck/Connect/ConnectTruck.vue';
import User from './views/User/User.vue';
import Company from './views/Company/Company.vue';
import GasStation from './views/Company/GasStation/GasStation.vue';
import CrudUser from './views/User/Crud/User.vue';
import ChangeEmail from './views/User/ChangeEmail/ChangeEmail.vue';
import ChangePassword from './views/User/ChangePassword/ChangePassword.vue';
import AlertFleetDriver from './views/Alert/FleetDriver/Alert.vue';
import AlertAdmin from './views/Alert/Admin/Alert.vue';
import Chat from './views/app/applications/Chat.vue';
import ApproveTrucker from './views/Trucker/Approve/Trucker.vue';
import Health from './views/Trucker/Health/Health.vue';
import ApproveTruckerFleetDriver from './views/Company/FleetDriver/Approve/Trucker.vue';
import ListUser from './views/User/List/User.vue';
import Curriculum from './views/Trucker/Curriculum/Curriculum.vue';
import ListTrucks from './views/Truck/List/Trucks.vue';
import Orders from './views/Orders/Orders.vue';
import Chart from './views/Charts/Admin/Charts.vue';
import ChartCompany from './views/Charts/Company/Charts.vue';
import searchPlate from './views/Plate/Plate.vue';
import HistoryOrdersAdmin from './views/HistoryOrders/HistoryOrders.vue';
import paymentMethod from './views/Company/PaymentMethods/PaymentMethods.vue';
import BankSlips from './views/Company/BankSlips/BankSlips.vue';
import Terms from './views/Terms/Terms.vue';
import VueSession from 'vue-session';//https://github.com/victorsferreira/vue-session
import ReportTruck from './views/Report/Truck/Truck.vue';
import ReportTrucker from './views/Report/Trucker/Trucker.vue';
import IndicationUses from './views/Report/Indication/ListIndication.vue';
import Banner from './views/Banner/Banner.vue';
import MyOrders from './views/Company/FleetDriver/MyOrders/MyOrders.vue';
import PrivacyData from './views/PrivacyData/PrivacyData.vue';
import SystemConfigFamily from './views/Products/Families/Family.vue';
import SystemConfigService from './views/Products/Services/Service.vue';
import SystemConfigManufacturer from './views/Products/Manufacturer/Manufacturer.vue';
import SystemConfigModel from './views/Products/Model/Model.vue';
import SystemConfigGasStation from './views/User/GasStation/GasStation.vue';
import CompaniesFound from './views/Report/CompaniesFound/CompaniesFound.vue';
import ListTermAccepted from './views/Report/TermsAccepted/ListTermAccepted.vue';
import RequestAdmin from './views/Admin/Request/Request.vue';
Vue.use(VueSession)
Vue.use(Router)

const session = Vue.prototype.$session;


const checkSession = () => {
  let user = session.get('user');
  let isUser = session.exists('user');
  let isToken = session.exists('token');


  if (!isUser || !isToken) {
    session.destroy();
    return '/';//redirect to login page
  } else {
    let href = window.location.href
    if (user.companyUser.subtype != 'ADMIN_MASTER' && href.indexOf('/payment-method') == -1 && href.indexOf('/dashboard') == -1) {
      let rout = checkInfos();
      if (rout) {
        window.location.href = "?#/" + rout;
        return rout;
      }

    }

    return;
  }
}

const checkInfos = () => {
  let user = session.get('user');
  if (user.companyUser && user.companyUser.company) {
    // if (!user.companyUser.company.paymentType){
    //   return '/payment-method';
    // }else 
    if (!user.isAcceptGeneralTerms || !user.isAcceptPurchaseTerms) {
      return '/dashboard';
    }
  }
  return;
}

function checkCard() {
}

// const checkCardByCompany = () => {
//   if (checkCard()){
//     return 'payment-method';
//   }
//   else{
//     return;
//   }
// }

export default new Router({
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/logout',
      name: 'logout',
      component: Logout
    },
    {
      path: '/users',
      name: 'users',
      component: User
    },
    {
      path: '/companies',
      name: 'companies',
      component: Company
    },
    {
      path: '/gas-station',
      name: 'gas-station',
      component: GasStation,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/crud-companies',
      name: 'crud-companies',
      component: CrudCompany,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/perfil-trucks',
      name: 'perfil-trucks',
      component: PerfilTruck,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/list-orders',
      name: 'list-orders',
      component: Orders,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/perfil-trucks-trailer',
      name: 'perfil-trucks-trailer',
      component: PerfilTruckTrailer,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/chart',
      name: 'chart',
      component: Chart,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/chart-company',
      name: 'chart-company',
      component: ChartCompany,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/perfil-trucks-service',
      name: 'perfil-trucks-service',
      component: PerfilTruckService,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/perfil-certifies',
      name: 'perfil-certifies',
      component: PerfilCertified,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/work-hours',
      name: 'work-hours',
      component: WorkHours,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/crud-trucktrailer',
      name: 'crud-trucktrailer',
      component: TruckTrailer,
      // beforeEnter: (to, from, next) => {
      //   next(checkSession());
      // }
    },
    {
      path: '/crud-truck',
      name: 'crud-truck',
      component: Truck,
      props: true
      // beforeEnter: (to, from, next) => {
      //   next(checkSession());
      // }
    },
    {
      path: '/truck-admin/:truckId',
      name: 'truck-admin',
      props: true,
      component: TruckAdmin,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/truck-admin',
      name: 'truck-admin',
      props: true,
      component: TruckAdmin,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/trucktrailer-admin/:truckTraillerId',
      name: 'trucktrailer-admin',
      props: true,
      component: TruckTrailerAdmin,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/trucktrailer-admin',
      name: 'trucktrailer-admin',
      props: true,
      component: TruckTrailerAdmin,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/connect-truck',
      name: 'connect-truck',
      component: ConnectTruck,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/crud-user',
      name: 'crud-user',
      component: CrudUser,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/change-email',
      name: 'change-email',
      component: ChangeEmail,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/panic-alert-fleetdriver',
      name: 'panic-alert-fleetdriver',
      component: AlertFleetDriver,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/panic-alert',
      name: 'panic-alert',
      component: AlertAdmin,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/change-password',
      name: 'change-password',
      component: ChangePassword,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/chat',
      name: 'chat',
      component: Chat,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/approve-trucker',
      name: 'approve-trucker',
      component: ApproveTrucker,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/approve-trucker-fleet-driver',
      name: 'approve-trucker-fleet-driver',
      component: ApproveTruckerFleetDriver,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/health',
      name: 'health',
      component: Health,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/list-user',
      name: 'list-user',
      component: ListUser,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/list-trucks',
      name: 'list-trucks',
      component: ListTrucks,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/company-registration',
      name: 'company-registration',
      component: CompanyRegistration,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/trucker',
      name: 'trucker',
      component: Trucker,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/trucker-fleet-driver',
      name: 'trucker-fleet-driver',
      component: TruckerFleetDriver,
      //beforeEnter: (to, from, next) => {
      //   next(checkSession());
      // }
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/dashboard-fleet-driver',
      name: 'dashboard-fleet-driver',
      component: DashboardFleetDriver,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/product-groups',
      name: 'product-groups',
      component: ProductGroupd,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/product-families',
      name: 'product-families',
      component: ProductFamily,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/product-brands',
      name: 'product-brands',
      component: ProductBrand,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/product-parts',
      name: 'product-parts',
      component: ProductParts,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }

    },
    {
      path: '/fleetdriver-request',
      name: 'fleetdriver-request',
      component: Request,
      // beforeEnter: (to, from, next) => {
      //   next(checkSession());
      // }
    },
    {
      path: '/history-orders-admin',
      name: 'history-orders-admin',
      component: HistoryOrdersAdmin,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/payment-method',
      name: 'payment-method',
      component: paymentMethod,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/bank-slips',
      name: 'bank-slips',
      component: BankSlips,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/terms',
      name: 'terms',
      component: Terms,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/search-plate',
      name: 'search-plate',
      component: searchPlate,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/curriculums',
      name: 'curriculums',
      component: Curriculum,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/report-truck',
      name: 'report-truck',
      component: ReportTruck,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/report-trucker',
      name: 'report-trucker',
      component: ReportTrucker,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/indication-uses',
      name: 'indication-uses',
      component: IndicationUses,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/companies-found',
      name: 'companies-found',
      component: CompaniesFound,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/reports/terms-accepted',
      name: 'terms-accepted',
      component: ListTermAccepted,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/banner',
      name: 'banner',
      component: Banner,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/system-config-family',
      name: 'system-config-family',
      component: SystemConfigFamily,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/system-config-service',
      name: 'system-config-service',
      component: SystemConfigService,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/system-config-manufacturer',
      name: 'system-config-manufacturer',
      component: SystemConfigManufacturer,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/system-config-model',
      name: 'system-config-model',
      component: SystemConfigModel,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/system-config-gasstation',
      name: 'system-config-gasstation',
      component: SystemConfigGasStation,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
    {
      path: '/my-orders',
      name: 'my-orders',
      component: MyOrders,
      // beforeEnter: (to, from, next) => {
      //   next(checkSession());
      // }
    },
    {
      path: '/privacydata',
      name: 'privacydata',
      component: PrivacyData,
      // beforeEnter: (to, from, next) => {
      //   next(checkSession());
      // }
    },
    {
      path: '/request-admin',
      name: 'request-admin',
      component: RequestAdmin,
      beforeEnter: (to, from, next) => {
        next(checkSession());
      }
    },
  ]
});